import { Button, Drawer, Modal, Tabs } from 'antd'
import { SupportApi } from 'api/Support'
import TimelineFeedCont from 'components/Common/TimelineFeed/TimelineFeedCont'
import SupportTicketForm from 'components/Main/SupportTicket/SupportTicketForm'
import useFetch from 'elements/Hooks/useFetch'
import useModalData from 'elements/Hooks/useModalData'
import useModalShow from 'elements/Hooks/useModalShow'
import DateCell from 'elements/Table/Cells/DateCell'
import StatusCell from 'elements/Table/Cells/StatusCell'
import CustomTable from 'elements/Table/CustomTable'
import { GlobalContext } from 'Global'
import React from 'react'
import { isEmpty } from 'lodash'

function SupportTicketDrawer(props) {
  const { visible, submitting, submit, formRef, onShow, onCancel } = useModalData(
    (data) => SupportApi.create(data),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    () => {
      onCancel()
    }
  )

  const { visible: visibleNotes, onShow: onShowNotes, onCancel: onCancelNote, payload } = useModalShow()

  console.log(payload)

  const { member } = React.useContext(GlobalContext)

  const { data, fetching, fetch } = useFetch({
    url: `support/owner/${(member._id || '').replace('members/', '')}`,
    dependencyArray: [member],
    dontFetch: isEmpty(member),
  })

  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({ value, original }) => <a onClick={() => onShowNotes(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateCell,
    },
    {
      Header: 'status',
      accessor: 'status',
      Cell: StatusCell,
    },
  ]

  const Footer = () => (
    <div className="space-x-2">
      <Button type="primary" onClick={submit} loading={submitting}>
        Submit
      </Button>
      <Button type="danger" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  return (
    <>
      <div onClick={onShow}>{props.children}</div>
      <Drawer
        title="Support Ticket"
        placement="right"
        width={720}
        onClose={onCancel}
        bodyStyle={{ paddingBottom: 80 }}
        visible={visible}>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Submit a ticket" key="1">
            <SupportTicketForm ref={formRef} />
            <Footer />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Tickets List" key="2">
            <NotesModal {...{ visible: visibleNotes, onCancel: onCancelNote, data: payload.object }} />
            <CustomTable
              {...{
                data,
                fetch,
                fetching,
                columns,
              }}
            />
          </Tabs.TabPane>
        </Tabs>
      </Drawer>
    </>
  )
}

const NotesModal = ({ visible, onCancel, data = {} }) => (
  <Modal title="Notes" visible={visible} onCancel={onCancel} width={'75%'}>
    <TimelineFeedCont owner={data._id} hideNotification />
  </Modal>
)

export default SupportTicketDrawer
